<template>
  <div class="w-100">
    <div
        class="modal fade"
        ref="exampleModal"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
      <div class="vertical-alignment-helper">
        <div class="modal-dialog modal-lg vertical-align-center">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Add Public Holiday
              </h5>
              <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="mb-3 row">
                <label for="inputDate" class="col-sm-2 col-form-label"
                >Date</label
                >
                <div class="col-sm-10">
                  <Datepicker
                      v-model="payloadCreate.date"
                      :enableTimePicker="false"
                      :format="'dd MMM yyyy'"
                      :autoApply="true"
                      
                  ></Datepicker>
                </div>
              </div>
              <div class="mb-3 row">
                <label for="staticDay" class="col-sm-2 col-form-label">Day</label>
                <div class="col-sm-10">
                  <input
                      type="text"
                      readonly
                      disabled
                      class="form-control"
                      id="staticDay"
                      v-bind:value="filters.dateToDay(payloadCreate.date)"
                  />
                </div>
              </div>
              <div class="mb-3 row">
                <label for="inputNote" class="col-sm-2 col-form-label">
                  Note<span class="text-danger">*</span>
                </label>
                <div class="col-sm-10 input-group" style="width: 83.33333333%">
                  <input
                      type="text"
                      class="form-control"
                      id="inputNote"
                      v-model="payloadCreate.note"
                      style="border-right-width: 0"
                      maxlength="56"
                  />
                  <span class="input-group-text" style="background-color: white;">{{
                      payloadCreate.note.length
                    }}/56</span>

                </div>
              </div>
            </div>
            <div class="modal-footer" style="display: initial">
              <button
                  type="button"
                  class="btn btn-outline-danger text-uppercase"
                  data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                  type="button"
                  :disabled="!payloadCreate.date"
                  class="btn btn-danger text-white text-uppercase"
                  @click="addNewPublicHoliday()"
              >
                Add Holiday
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12" style="display: flex; align-items: center; justify-content: space-between; align-content: center;">
      <div class="alert alert-warning d-flex align-items-center" role="alert">
        <font-awesome-icon icon="fa-solid fa-circle-info" style="margin-right: 10px;"/>
        <div>
          Note: This has higher priority than Business Days and Hours. This setting will override Business Days and Hours
        </div>
      </div>
      <button
          class="btn btn-danger text-white"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          style="text-align: left"
          @click="onClickAdd"
      >
        <img src="/img/ic_add_detail.c91528aa.svg" alt=""/>
        Add New
      </button>
    </div>

    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:date="{ data }">
        <div style="color: #5e50a1;" class="fw-bold">
        {{ filters.dateSimple(data.date) }}
        </div>
      </template>
      <template v-slot:day="{ data }">
        {{ filters.dateToDay(data.date) }}
      </template>
      <template v-slot:actions="{ data }">
        <div>
          <button
              class="btn"
              @click="onButtonDeleteClick(data.id, filters.dateSimple(data.date))"
          >
            <font-awesome-icon class="text-danger" icon="fa-solid fa-trash"/>
          </button>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  components: {
    TableBasic,
    Datepicker,
  },
  data() {
    return {
      payload: {
        header: [
          {
            key: "date",
            label: "Date",
            class: "text-start text-uppercase",
            sort: true,
            sort_key: 'date'
          },
          {
            key: "day",
            label: "Day",
            class: "text-start text-uppercase",
            sort: false,
          },
          {
            key: "note",
            label: "Note",
            class: "text-start text-uppercase",
            sort: false,
          },
          {
            key: "actions",
            label: "Actions",
            class: "text-start text-uppercase",
          },
        ],
        value: [],
        checkbox: false,
        filterLabel: "Filter Holiday",
        filter: false,
        search: false,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        startDate: "",
        endDate: "",
      },
      showMessage: false,
      payloadCreate: {
        date: "",
        note: "",
      },
    };
  },
  methods: {
    onClickAdd() {
      this.payloadCreate.date = ""
      this.payloadCreate.note = ""
    },
    changeParameter(value) {
      this.payload.perPage = value.per_page;
      this.payload.currentPage = value.current_page;
      this.payload.sort_by = value.sort_by
      this.payload.sort_type = value.sort_type
      this.getData();
    },
    async getData() {
      try {
        let payload = {
          page: this.payload.currentPage,
          size: this.payload.perPage,
          sort_by: this.payload.sort_by,
          sort_type: this.payload.sort_type,
        };
        const response = await this.$store.dispatch(
            "publicHoliday/getAll",
            payload
        );
        this.payload.value = response.data.data.items;
        this.payload.totalRows = response.data.data.count;
      } catch (error) {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      }
    },
    async addNewPublicHoliday() {
      try {
        let payloadCreate = {
          note: this.payloadCreate.note,
          date: this.filters.isoDate(this.payloadCreate.date),
        };
        await this.$store.dispatch("publicHoliday/create", payloadCreate);
        this.$swal({
          icon: "success",
          title: "Success Add Holiday.",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.$router.go();
        });
      } catch (error) {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      }
    },
    onButtonDeleteClick(deletePublicHolidayId, date) {
      console.log(deletePublicHolidayId, date);
      this.deletePublicHolidayId = deletePublicHolidayId;
      this.$swal({
        title: `Delete holiday on ${date} ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff434f",
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch(
              "publicHoliday/delete",
              this.deletePublicHolidayId
          );
          this.$swal({
            icon: "success",
            title: "Success delete holiday.",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.$router.go();
          });
        }
      }).catch((error) => {
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        })
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style>
.vertical-alignment-helper {
  display:table;
  height: 100%;
  width: 100%;
  pointer-events:none; /* This makes sure that we can still click outside of the modal to close it */
}
.vertical-align-center {
  /* To center vertically */
  display: table-cell;
  vertical-align: middle;
  pointer-events:none;
}
.modal-content {
  /* Bootstrap sets the size of the modal in the modal-dialog class, we need to inherit it */
  width:inherit;
  max-width:inherit; /* For Bootstrap 4 - to avoid the modal window stretching full width */
  height:inherit;
  /* To center horizontally */
  margin: 0 auto;
  pointer-events: all;
}
</style>
